import React from "react";
import Link from "../../../UI/Link";

export default function ColumnContent({columns = [], submenuStyles, Item}) {
    return (
        columns &&
        columns.map((column, colIdx) => (
            <div key={colIdx} className={submenuStyles.submenuMega__contentColumn}>
                <div>
                    {column.title && <p className={submenuStyles.submenuMega__label}>{column.title}</p>}
                    <ul
                        className={`${submenuStyles.contentColumn__list} ${
                            colIdx === 0 && column.items.length < 6 ? submenuStyles.contentColumn__list_half : ""
                        } ${
                            colIdx === 0 && column.items.length >= 6 ? submenuStyles.contentColumn__list_two__col : ""
                        }`}
                    >
                        {column.items &&
                            column.items.map((item, itemIdx) => (
                                <li
                                    key={`${item?.id ?? "colitem"}-${itemIdx}`}
                                    className={`${submenuStyles.contentColumn__item} `}
                                >
                                    {item.link ? (
                                        <a
                                            href={item.link?.url}
                                            className={submenuStyles.contentColumn__link}
                                            target={item.link?.url?.newTab ? "_blank" : "_self"}
                                            rel="noreferrer"
                                        >
                                            <Item key={item.id ?? itemIdx} item={item} />
                                        </a>
                                    ) : (
                                        <Item key={item.id ?? itemIdx} item={item} />
                                    )}
                                </li>
                            ))}
                    </ul>
                </div>
                <div className={submenuStyles.contentColumn__footer}>
                    {(column.footerLink || (Array.isArray(column.footer) && column.footer[0])) && (
                        <Link
                            className={submenuStyles.footerLink}
                            partiallyActive
                            to={(column.footerLink || column.footer[0]).url}
                        >
                            {(column.footerLink || column.footer[0]).text}
                        </Link>
                    )}
                </div>
            </div>
        ))
    );
}
